import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import addbtn from '../../../safreeimg/addbtn.png';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Infoimg from '../../../safreeimg/info.png';
import Excelimg from '../../../safreeimg/excelimg.png';
import DemoExcel from '../../../safreeimg/demo.xlsx';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const OrgUserManagement = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    mobileCountryCode: '',
    mobile: '',
    os: '',
    image: null,
    termsAccepted: false,
  });

  const [visiblePasswords, setVisiblePasswords] = useState({});
const [isEditing, setIsEditing] = useState(false);
const [editingUserId, setEditingUserId] = useState(null);

  // ✅ Function to toggle password visibility
  const togglePasswordVisibility = (userId) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));
  };

  const rowsPerPage = 10;
  const navigate = useNavigate();
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = DemoExcel;
    link.download = "demo.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      const response = await axios.get(
        'https://api.safree.org/api-v2022/organization/auth/v1/organizationUsers',
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setUsers(response.data.data);
      } else {
        setError('Failed to fetch users');
      }
    } catch (err) {
      console.error('Error fetching users:', err);
      setError('An error occurred while fetching users: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInfoButtonClick = () => {
    setShowInfoPopup(!showInfoPopup);
  };

  const handleDeleteUser = async (userId) => {
    const confirmation = window.confirm('Are you sure you want to delete this user?');
    if (!confirmation) return;

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('Authentication token is missing. Please log in again.');
        return;
      }

      setLoading(true);
      const response = await axios.delete(
        `https://api.safree.org/api-v2022/organization/auth/v1/delete-user/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        alert('User deleted successfully.');
        setUsers(users.filter((user) => user.userId !== userId));
      } else {
        alert('Failed to delete the user. Please try again.');
      }
    } catch (err) {
      console.error('Error deleting user:', err);
      alert(`An error occurred while deleting the user: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
  };

  const handlePhoneChange = (value) => {
    const countryCode = value ? value.slice(0, 4) : '';
    const phoneNumber = value ? value.slice(4) : '';

    setFormData((prev) => ({
      ...prev,
      mobileCountryCode: countryCode,
      mobile: phoneNumber,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem('token');
  if (!token) {
    alert('Authentication token is missing. Please log in again.');
    return;
  }

  try {
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    if (isEditing && editingUserId) {
      formDataToSend.append('userId', editingUserId); // Include userId for edit
      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/edit-user-details',
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        alert('User updated successfully!');
        fetchData();
      } else {
        alert('Failed to update user. Please try again.');
      }
    } else {
      // Original create user logic
      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/createUser',
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        alert('User added successfully!');
        setUsers((prev) => [...prev, response.data.data]);
        fetchData();
      } else {
        alert('Failed to add user. Please try again.');
      }
    }

    // Reset form
    setFormData({
      name: '',
      email: '',
      password: '',
      mobileCountryCode: '',
      mobile: '',
      os: '',
      image: null,
      termsAccepted: 0,
    });
    setIsEditing(false);
    setEditingUserId(null);
    setShowForm(false);

  } catch (err) {
    console.error('Error in form submission:', err);
    alert(`An error occurred: ${err.message}`);
  }
};


  const toggleOrganizationPlanStatus = async (index, user, currentStatus) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Authentication token is missing or expired. Please log in again.");
        return;
      }

      const newStatus = !currentStatus;
      const requestBody = {
        userId: user.userId,
        status: newStatus,
      };

      const response = await axios.post(
        "https://api.safree.org/api-v2022/organization/auth/v1/user/update/subscription",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setUsers((prevUsers) =>
          prevUsers.map((u, i) =>
            i === index ? { ...u, isOrganizationPlan: newStatus } : u
          )
        );
        alert(response.data.message || "Subscription status updated successfully!");
      } else {
        alert(response.data.message || "Failed to update subscription status.");
      }
    } catch (error) {
      console.error("Error updating user status:", error.response?.data || error);
      alert("Please upgrade plan to select more users");
    }
  };

  const handleUpload = async () => {
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('Authentication token is missing. Please log in again.');
        return;
      }

      const formData = new FormData();
      const fileInput = document.getElementById('fileUpload');
      const file = fileInput.files[0];

      if (!file) {
        alert('Please select an Excel file to upload.');
        return;
      }

      formData.append('excelData', file);

      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/upload/excelData',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        const data = response.data.data;

        if (data && data.length > 0) {
          setUploadedData(data);
          setShowPopup(true);
          alert('File uploaded successfully!');
        } else {
          alert('File uploaded successfully! No similar data found.');
        }

        fetchData();
      } else {
        alert('Failed to upload the file. Please try again.');
      }

    } catch (err) {
      console.error('Error uploading Excel file:', err);
      alert(`An error occurred while uploading: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  const handleEditUser = (user) => {
  setFormData({
    name: user.name || '',
    email: user.email || '',
    password: user.plainPassword || '',
    mobileCountryCode: user.mobileCountryCode || '',
    mobile: user.mobile || '',
    os: user.os || '',
    image: null,
    termsAccepted: user.termsAccepted ? 1 : 0,
  });
  setEditingUserId(user.userId);
  setIsEditing(true);
  setShowForm(true);
};


  if (loading) return <div className="loading"><img src={Loader} alt="Loading..." /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-4">
          <p className="sub-heading">User Management</p>
        </div>
        <div className="col-md-4 file-upload-section">
          <input
            type="file"
            id="fileUpload"
            onChange={handleFileChange}
            accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <button className='sendbtn' onClick={handleUpload}>
            {isSubmitting ? (
              <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
              </div>
            ) : (
              'Send'
            )}
          </button>
          <button className='infobtns' onClick={handleInfoButtonClick}>
            <img src={Infoimg} alt="" />
          </button>
        </div>
        <div className="col-md-4 hedrcol2 nchnge">
          <h3 onClick={() => setShowForm(true)} style={{ cursor: 'pointer' }}>
            Add New User <img src={addbtn} alt="" />
          </h3>
        </div>
      </div>

      {/* Info Popup */}
      {showInfoPopup && (
        <div className="info-popup">
          <div className="popup-content">
            <span className="close-btn" onClick={handleInfoButtonClick}>X</span>
            <button class="Btn" onClick={handleDownload}>
              <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
              <span class="icon2"></span>
              <span class="tooltip">Download</span>
            </button>
            <h3>Information</h3>
            <p>Here the example of Excelsheet information.</p>
            <img src={Excelimg} alt="" />
          </div>
        </div>
      )}

      {showPopup && (
        <div className="popup-overlay secdpopup" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="closes-btn" onClick={() => setShowPopup(false)}>X</span>
            <h3 className='datah'>Duplicate Entries Exist, System will skip them automatically</h3>

            {uploadedData && uploadedData.length > 0 ? (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                  </tr>
                </thead>
                <tbody>
                  {uploadedData.map((user, index) => (
                    <tr key={index}>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.phoneNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No similar data found.</p>
            )}
          </div>
        </div>
      )}

      <div className="table-container tbcon">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Password</th>
              <th>User Guardians</th>
              <th>User is Guarding</th>
              <th>Alarms</th>
              <th>Location</th>
              <th>Subscription Status</th>
              <th>Edit</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((user, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.phoneNumber}</td>
                <td>
                  {visiblePasswords[user.userId] ? (
                    <>
                      {user.plainPassword || 'N/A'}{" "}
                      <FaEyeSlash
                        style={{ cursor: 'pointer' }}
                        onClick={() => togglePasswordVisibility(user.userId)}
                      />
                    </>
                  ) : (
                    <>
                      {"*".repeat(user.plainPassword?.length || 8)}{" "}
                      <FaEye
                        style={{ cursor: 'pointer' }}
                        onClick={() => togglePasswordVisibility(user.userId)}
                      />
                    </>
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => navigate(`../orgUserManagement/orgUserGuardians/#${user.userId}`)}
                  >
                    View
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => navigate(`../orgUserManagement/orgUserisGuardians/#${user.userId}`)}
                  >
                    View
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => navigate(`../orgUserManagement/orgUserAlarms/#${user.userId}`)}
                  >
                    View
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => navigate(`../orgUserManagement/orgUserMap/#${user.userId}`)}
                  >
                    View
                  </button>
                </td>
                <td>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={user.isOrganizationPlan}
                      onChange={() => toggleOrganizationPlanStatus(index, user, user.isOrganizationPlan)}
                    />
                    <span className="slider round"></span>
                  </label>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => handleEditUser(user)}
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => handleDeleteUser(user.userId)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {getPageNumbers().map((page) => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>

      <div className={`side-form orgeusercret ${showForm ? 'show' : ''}`}>
        <form onSubmit={handleSubmit}>
          <h3>Add New User</h3>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
          <PhoneInput
            international
            defaultCountry="IN"
            value={formData.mobileCountryCode + formData.mobile}
            onChange={handlePhoneChange}
            required
          />
          <select
            name="os"
            value={formData.os}
            onChange={handleInputChange}
            required
          >
            <option value="">Select OS</option>
            <option value="Android">Android</option>
            <option value="iOS">iOS</option>
          </select>
          <input
            type="file"
            name="image"
            onChange={handleFileChange}
          />
          <label className='checkbox'>
            <input
              type="checkbox"
              name="termsAccepted"
              checked={formData.termsAccepted === 1}
              onChange={(e) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  termsAccepted: e.target.checked ? 1 : 0,
                }))
              }
            />
            I accept the terms and conditions
          </label>
          <button type="submit" className="btn-save">
            Save Details
          </button>
          <button type="button" className="btn-cancel" onClick={() => setShowForm(false)}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrgUserManagement;
